__turbopack_context__.v({
  "container": "Container-module__v1nOZW__container",
});
